import Parse from "parse";

import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

import { useGame } from "../header/GameContext";
import { CHAT_DATA } from "../chat/chatData";

import Header from "../header/header";
import ChatBoxType2 from "../chat/chatType2";
import QuizeCheck from "./quizeCheck";
import Wrong from "../wrong/wrong";
import Hint from "../hint/hint";

import "./quiz.css";

export default function Quize() {
  const location = useLocation();
  const navigate = useNavigate();

  const { DB_TABLE } = useGame();

  const [showWrong, setShowWrong] = useState(false);
  const [hintWhether, setHintWhether] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const chatRef = useRef(null);

  // answerData //스테이지 키(q1, q2...)
  // DateVal //채팅(문제) 키
  const state = location.state || {};
  const { answerData, DateVal, titImgClass, hintWhetherIs, hintContent } =
    state;

  useEffect(() => {
    const saveStage = async () => {
      try {
        const GameUser = Parse.Object.extend(DB_TABLE);
        const query = new Parse.Query(GameUser);
        const objectId = localStorage.getItem("gameUserId");
        const user = await query.get(objectId);

        user.addUnique("access_stage", DateVal);
        await user.save();
      } catch (error) {
        console.error("에러 코드:", error.code);
        console.error("에러 메시지:", error.message);
      }
    };

    saveStage();
  }, [DateVal]);

  const contents = CHAT_DATA[DateVal];

  useEffect(() => {
    setHintWhether(hintWhetherIs);
  }, [hintWhetherIs]);

  return (
    <div id="content">
      <Header />

      <div className="box box_con con_box1 con_pd5 con_box_c ans0001">
        {titImgClass && (
          <div className={`mission_tit ${titImgClass} mt24`}>
            {hintWhether && (
              <a className="hint_d" onClick={() => setShowHint(true)}>
                <span className="hint_in hint_icon mr4"></span>
                <span className="hint_in hint_txt">정답보기</span>
              </a>
            )}
          </div>
        )}

        <ChatBoxType2
          DateVal={contents}
          titImgClass={titImgClass}
          ref={chatRef}
        />

        <QuizeCheck
          onWrong={() => setShowWrong(true)}
          answerData={answerData}
        />

        {showWrong && <Wrong onClose={() => setShowWrong(false)} />}
        {showHint && (
          <Hint hintContent={hintContent} onClose={() => setShowHint(false)} />
        )}
      </div>
    </div>
  );
}
